import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService, TextDocument } from '../../../shared/dataService';

@Component({
  selector: 'app-document-versions',
  templateUrl: './document-versions.component.html',
  styleUrls: ['./document-versions.component.scss']
})
export class DocumentVersionsComponent implements OnInit {
  document: TextDocument | null = null;
  isLoading = true;
  isError = false;
  selectedVersions: string[] = [];
  documentId: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dataService: DataService
  ) {}

  ngOnInit(): void {
    this.documentId = this.route.snapshot.paramMap.get('id');
    if (this.documentId) {
      this.fetchDocument(this.documentId);
    } else {
      this.isError = true;
      this.isLoading = false;
    }
  }

  private fetchDocument(id: string): void {
    this.isLoading = true;
    this.isError = false;
    
    this.dataService.getDocumentById(id).subscribe({
      next: (document) => {
        this.document = document;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error fetching document:', error);
        this.isError = true;
        this.isLoading = false;
      }
    });
  }

  onCheckboxChange(versionId: string, checked: boolean): void {
    if (checked) {
      if (this.selectedVersions.length < 2) {
        this.selectedVersions = [versionId, ...this.selectedVersions];
      }
    } else {
      this.selectedVersions = this.selectedVersions.filter(id => id !== versionId);
    }
  }

  isVersionSelected(versionId: string): boolean {
    return this.selectedVersions.includes(versionId);
  }

  isVersionDisabled(versionId: string): boolean {
    return this.selectedVersions.length >= 2 && !this.selectedVersions.includes(versionId);
  }

  onCompare(): void {
    if (this.selectedVersions.length === 2 && this.documentId) {
      this.router.navigate(['/docs', this.documentId, 'versions', 'compare'], {
        queryParams: {
          id1: this.selectedVersions[0],
          id2: this.selectedVersions[1]
        }
      });
    }
  }

  getVersionNumber(index: number): number {
    if (!this.document || !this.document.versions) return 0;
    return this.document.versions.length - index;
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }
}

